import { render, staticRenderFns } from "./ScrollingMessages.vue?vue&type=template&id=16c44874&scoped=true"
import script from "./ScrollingMessages.vue?vue&type=script&lang=js"
export * from "./ScrollingMessages.vue?vue&type=script&lang=js"
import style0 from "./ScrollingMessages.vue?vue&type=style&index=0&id=16c44874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c44874",
  null
  
)

export default component.exports